import React, { Component } from 'react';
import { IonList, IonListHeader, IonItem, IonLabel } from '@ionic/react';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { isDefined, forwardTo } from '../../lib/utils';
import Basket from '../../lib/basket';
import { connect } from 'react-redux';
import NoData from '../../components/noData';
import { NormalText, SmallText, StrongText } from '../../components/common';
import { getConfig } from '../../appConfig';

class orderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calc: false,
    };
    this.ionList = null;
    this.orderListItems = null;
  }
  componentDidMount() {
    setTimeout(() => {
      const item = document.querySelector('.order-list-items');
      const itemList = document.querySelector('.order-list-items > ion-list');
      if (item && itemList) {
        this.ionList = itemList;
        // this.orderListItems = item
        if (this.ionList && this.orderListItems) {
          this.setState({ calc: true });
        }
        item.scrollTop = this.props.scrollTopPosition;
        // item.scrollBy({ top: 1, behavior: 'smooth' })
      }
    }, 500);
  }
  openItemPage = (item) => {
    this.props.searchBoxInput.current.blur();
    forwardTo('/item-details', item);
  };
  itemList = (__, subCategoryItems, i) => {
    const { profile } = this.props;

    return (subCategoryItems || []).map((item, index) => {
      if (item.sku === undefined || !Basket.isProductJustEnabled(item)) {
        return <span key={item.sku + '_disabled'} />;
      }
      let image =
        item.itemRichData && item.itemRichData.squareImageUrl
          ? item.itemRichData.squareImageUrl
          : '';
      if (image && image.indexOf('http://') !== -1) {
        image = image.replace(/http:\/\//g, 'https://');
      }
      item.selectedMenu = [];
      return (
        <IonItem
        lines='none'
          className={!Basket.isProductUnsnoozed(item) ? 'disabled-element' : ''}
          key={item.sku + '_' + index + i}
          onClick={() => (Basket.isProductUnsnoozed(item) ? this.openItemPage(item) : null)}
        >
          <div tabIndex="-1" className="order-list-item">
            <div className="item-content">
              <NormalText className="item-name dark-color">
                {__(Basket.getProductName(item, profile))}
              </NormalText>
              <SmallText
                className="block  dark-color"
                dangerouslySetInnerHTML={{
                  __html: Basket.getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
                }}
              />
              <NormalText className="secondary-font item-price dark-color">
                <NormalText className="secondary-font item-price dark-color">
                  {Basket.formatPrice(item.productPrice)}
                </NormalText>
                {item.originalPrice ? (
                  <>
                    <NormalText className="secondary-fon original-price dark-color">
                      &#163;{item.originalPrice}
                    </NormalText>
                  </>
                ) : null}
              </NormalText>
            </div>
            {image && image !== '' ? (
              <div className="item-image-wrapper">
                <div className="item-image" style={{ backgroundImage: 'url(' + image + ')' }} />
              </div>
            ) : null}
          </div>
        </IonItem>
      );
    });
  };

  drawCategoryItems = (
    __,
    category,
    items,
    breadCrumb = null,
    i,
    isGroup = false,
    allGroup = false,
  ) => {
    let name = category.name ? breadCrumb + category.name : breadCrumb + '';
    let drawSubCategory = isGroup ? (
      <div className="order-sublist-holder" ref={this.props.menuRefs[`${name}_${i}`]}>
        <IonListHeader className={allGroup ? 'order-sublist-header' : 'order-sublist-header empty'}>
          <IonLabel>{name}</IonLabel>
        </IonListHeader>
        {this.subCategoriesList(__, category, breadCrumb + category.name)}
      </div>
    ) : (
      <>{items}</>
    );

    return <div  key={category.type + '_' + name + i}>{drawSubCategory}</div>;
  };

  breadCrumb = (name) => {
    let breadCrumb = name !== '' ? name + ' | ' : name;
    return breadCrumb;
  };

  subCategoriesList = (__, category, name) => {
    if (!isDefined(category)) {
      return <NoData />;
    }
    const categoryItems = category.menuEntry || category.menuEntryGroups || null;
    let items = this.itemList(__, categoryItems);
    let breadCrumb = this.breadCrumb(name);
    if (categoryItems) {
      return categoryItems
        .map((subCategory, index) => {
          if (subCategory['@type'] === 'group') {
            items = this.itemList(__, subCategory.menuEntry, index);
            const allGroup = subCategory.menuEntry.some((item) => item.type !== 'group');
            return this.drawCategoryItems(
              __,
              subCategory,
              items,
              breadCrumb,
              index,
              true,
              allGroup,
            );
          } else {
            items = this.itemList(__, [subCategory], index);
            return this.drawCategoryItems(__, subCategory, items, name, index, false);
          }
        });
    }
    return this.drawCategoryItems(__, category, items, name, 0);
  };

  calcHeight = () => {
    const { category } = this.props;
    let height = 0;
    if (this.ionList && this.orderListItems && isDefined(category)) {
      let orderListHeight = this.orderListItems.clientHeight;
      let allSublist = document.querySelectorAll('.order-sublist-holder');
      let allOrderListItems = document.querySelectorAll('.order-list-item');
      if (allSublist.length > 0 && allOrderListItems.length > 0) {
        let lastSubList = allSublist[allSublist.length - 1];
        let lastItem = allOrderListItems[allOrderListItems.length - 1];
        let lastItemStyles = window.getComputedStyle(lastItem);
        if (lastSubList && orderListHeight) {
          height = orderListHeight - lastSubList.clientHeight + lastItem.clientHeight - 50;
        }
      }
    }

    return height;
  };
  render() {
    const { __, category } = this.props;
    const { calc } = this.state;
    return (
      <div
        className="order-list-items"
        id="order-list-items"
        onScroll={(e) => this.props.selectCategoryOnScroll(e)}
        ref={(ref) => (this.orderListItems = ref)}
      >
        <IonList lines="none" ref={(ref) => (this.ionList = ref)}>
          {this.subCategoriesList(__, category, '')}
        </IonList>
        <div className='order-page-text' style={{marginBottom:Basket.itemsCountAll()>0?'80px':'30px'}}>
        <NormalText>{__(getConfig().general.orderPageText)}</NormalText>

        </div>

        {/* <div style={{ height: this.calcHeight() }}></div> */}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    profile: store.profile.profile,
    restaurantsUpdated: store.restaurants.restaurantsUpdated,
    basketUpdated: store.orders.basketUpdated,
  };
};

export default connect(mapStateToProps)(withTranslation(orderList));
